
import React from 'react';
import { Button } from '@/components/ui/button';
import AnimateInView from '@/components/ui/animate-in-view';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const ContactFAQ = () => {
  const faqs = [
    {
      question: "How quickly can you implement a security solution?",
      answer: "Every property is unique. After an initial consultation, we typically require 2-4 weeks for a standard installation, though expedited services are available for high-priority situations."
    },
    {
      question: "Do your security solutions require regular maintenance?",
      answer: "Our fiber-optic and on-fence solutions are engineered for minimal maintenance. We provide quarterly check-ups and offer comprehensive service plans to ensure optimal performance year-round."
    },
    {
      question: "Can your systems integrate with my existing security infrastructure?",
      answer: "Yes, our solutions are designed to complement and enhance existing security systems. We offer seamless integration with most major security platforms and can customize our approach based on your current setup."
    },
    {
      question: "What makes your security solutions different from traditional options?",
      answer: "Our technologies are invisible yet sophisticated, offering detection without visible intrusion. Unlike traditional systems that react after a breach, our solutions provide early warning through advanced fiber optics and AI analysis that can differentiate between threats and false alarms."
    }
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <AnimateInView animation="fade-in">
          <div className="text-center mb-10">
            <div className="h-0.5 bg-gold w-20 mx-auto mb-4"></div>
            <h2 className="text-2xl text-forti-fi mb-6">Frequently Asked Questions</h2>
          </div>
          
          <div className="space-y-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border border-forti-fi-lavender/30 rounded-lg mb-4 shadow-sm">
                  <AccordionTrigger className="px-6 py-4 hover:no-underline">
                    <span className="text-lg font-medium text-forti-fi">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 text-forti-fi-charcoal">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          
          <div className="mt-10 text-center">
            <Button variant="outline" asChild>
              <a href="#contact-form">Have More Questions? Contact Us</a>
            </Button>
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default ContactFAQ;
